import { Coins } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCredits } from "@/context/CreditsContext";

// Compact credits balance pill — tapping it opens the Wallet. Dark variant for
// the mobile header, light variant for the desktop sidebar.
export function CreditsChip({ dark = false, className = "" }) {
  const nav = useNavigate();
  const { credits } = useCredits();
  const bal = credits == null ? "—" : credits.toLocaleString();
  const low = typeof credits === "number" && credits <= 2;
  const palette = low
    ? (dark ? "border-[#C8000F]/60 bg-[#C8000F]/20 text-[#FF7A82] active:bg-[#C8000F]/30 px-2.5 py-1.5" : "border-[#C8000F]/50 bg-[#FBE9EA] text-[#C8000F] hover:bg-[#F7D9DB] px-3 py-1.5")
    : (dark ? "border-[#E6B35A]/40 bg-[#E6B35A]/10 text-[#E6B35A] active:bg-[#E6B35A]/20 px-2.5 py-1.5" : "border-[#E6B35A]/50 bg-[#FBF4E6] text-[#8A5A00] hover:bg-[#F3E6C6] px-3 py-1.5");
  return (
    <button onClick={() => nav("/wallet")} data-testid="credits-chip" title={low ? "Low on credits — tap to top up" : "Your Rodeo Credits"}
      className={`inline-flex items-center gap-1.5 rounded-full border font-bold text-xs transition-colors ${palette} ${className}`}>
      <Coins className="w-3.5 h-3.5" /> {bal}
    </button>
  );
}
